<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__operations}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-select
          v-model="isactiveDate"
          style="width: 100px"
          placeholder="请选择"
        >
          <el-option
            v-for="item in dateList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-form-item v-if="activeDate">
          <el-date-picker
            v-model="dataForm.date"
            type="date"
            placeholder="日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
         
        </el-form-item>
        <el-form-item v-else label="">
            <wPickers v-model="dateValue" @input="getTimes"></wPickers>
          </el-form-item>
        <el-form-item>
          <el-select
            v-model="dataForm.companyId"
            filterable
            clearable
            placeholder="机构"
          >
            <el-option
              v-for="item in companys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <wList
            v-model="dataForm.channelName"
            dataUrl="/sys/channels/list"
            placeholder="平台" 
            name="name"
          ></wList>
        </el-form-item>
        <el-form-item>
          <renSelect
            v-model="dataForm.city"
            dictType="landing_page_city"
            originPage="put"
            placeholder="城市"
          ></renSelect>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
      </el-form>
      <!-- <el-table v-loading="dataListLoading" :data="dataList" border  style="width: 100%;">
          <el-table-column prop="companyName" label="公司名" header-align="center" align="center"></el-table-column>
          <el-table-column prop="nums" label="推送条数" header-align="center" align="center"></el-table-column>
        </el-table> -->
      <el-table
        v-loading="dataListLoading"
        :data="tableData"
        :span-method="objectSpanMethod"
        border
        max-height="601"
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column
          prop="date"
          label="日期"
          header-align="center"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="机构"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="channelName"
          label="平台"
          header-align="center"
          align="center"
        >
        </el-table-column>
      
        <el-table-column
          prop="city"
          label="城市"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column label="各星级客户份额"  align="center">
        <el-table-column
          prop="total"
          label="有效客户数量"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="sporadic"
          label="0星"
          header-align="center"
          align="center"
        >
        </el-table-column> -->
        <el-table-column
          prop="oneStar"
          label="0星/1星"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="twoStar"
          label="1.5星/2星"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="threeStar"
          label="3星"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="fourStar"
          label="4星"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="fiveStar"
          label="5星"
          header-align="center"
          align="center"
        >
        </el-table-column>
      </el-table-column>
      </el-table>

      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <!-- <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update> -->
    </div>
  </el-card>
</template>
  
  <script>
import mixinViewModule from "@/mixins/view-module";
//   import AddOrUpdate from './operations-add-or-update'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/customers/qualityRateReport",
        getDataListIsPage: true,
        exportURL: "/sys/customers/export",
        deleteURL: "/sys/customers",
        deleteIsBatch: true,
      },
      dateList: [
        {
          value: 0,
          label: "日",
        },
        {
          value: 1,
          label: "时间段",
        },
      ],
      isactiveDate: 0,
      dateValue: "",
      dataForm: {
        id: "",
        date: "",
        companyId: "",
        city: "",
        startDate: "",
        endDate: "",
        channelName: '',
      },
      tableData: [],
      companys: [],
    };
  },
  computed: {
    activeDate(){

      console.log(this.isactiveDate)
      if(this.isactiveDate){
        this.dataForm.date = ''
      }else{
        this.dataForm.startDate = ''
        this.dataForm.endDate = ''
      }
      return this.isactiveDate == 0
    }
  },
  watch: {
    dataList: {
      handler(n, o) {
        console.log(n,'n')
        this.tableData = [];
        n.map((item) => {
          // console.log(item,'item')
          item.channels.map((item1) => {
         
            item1.cityQualityRate.map((item2) => {
              this.tableData.push({
                ...item,
                ...item1,
                ...item2,
              
                tab: `${item.customerName}${item1.channelName}`,
              });
            });
          });
        });
        console.log(this.tableData,'00000');
      },
    },
  },
  mounted() {
    this.getCompanysOptions();
  },
  methods: {
    getTimes() {
      if (this.dateValue != null) {
        this.dataForm.startDate = this.dateValue[0];
        this.dataForm.endDate = this.dateValue[1];
      } else {
        this.dataForm.startDate = "";
        this.dataForm.endDate = "";
      }
    },
    mergeCol(id, rowIndex) {
      // 合并单元格
      // id：属性名
      // rowIndex：行索引值
      var idName = this.tableData[rowIndex][id]; // 获取当前单元格的值
      console.log(rowIndex, "rowIndex");
      // console.log(idName)
      if (rowIndex > 0) {
        // 判断是不是第一行
        console.log("1", "rowIndex", rowIndex);
        // eslint-disable-next-line eqeqeq
        if (this.tableData[rowIndex][id] != this.tableData[rowIndex - 1][id]) {
          // 先判断当前单元格的值是不是和上一行的值相等
          var i = rowIndex;
          var num = 0; // 定义一个变量i，用于记录行索引值并进行循环，num用于计数
          while (i < this.tableData.length) {
            // 当索引值小于table的数组长度时，循环执行
            if (this.tableData[i][id] === idName) {
              // 判断循环的单元格的值是不是和当前行的值相等
              i++; // 如果相等，则索引值加1
              num++; // 合并的num计数加1
            } else {
              i = this.tableData.length; // 如果不相等，将索引值设置为table的数组长度，跳出循环
            }
          }
          return {
            rowspan: num, // 最终将合并的行数返回
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0, // 如果相等，则将rowspan设置为0
            colspan: 1,
          };
        }
      } else {
        // 如果是第一行，则直接返回
        console.log("2", "rowIndex", rowIndex);
        let i = rowIndex;
        let num = 0;
        while (i < this.tableData.length) {
          // 当索引值小于table的数组长度时，循环执行
          if (this.tableData[i][id] === idName) {
            i++;
            num++;
          } else {
            i = this.tableData.length;
          }
        }
        // console.log(num)
        return {
          rowspan: num,
          colspan: 1,
        };
      }
    },
    // 这个方法是 element-ui提供的单元格合并方法
    // objectSpanMethod 传入了 { row, column, rowIndex, columnIndex }
    // row: 当前行
    // column: 当前列
    // rowIndex：当前行号
    // columnIndex ：当前列号
    // 1代表：独占一行
    // 更大的自然数：代表合并了若干行
    // 0：代表“消失”的哪那一个单元格，后面的单元格向前推一格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
          return this.mergeCol("date", rowIndex);
      }
      if (columnIndex === 1) {
        console.log(this.mergeCol("customerName", rowIndex));
        return this.mergeCol("customerName", rowIndex);
      }
      if (columnIndex === 2) {
        return this.mergeCol("tab", rowIndex);
      }
      // if (columnIndex === 4) {
      //   return this.mergeCol("tab", rowIndex);
      // }
      // if (columnIndex === 5) {
      //   return this.mergeCol("companyName", rowIndex);
      // }
    },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http
        .get(`/sys/companies/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.companys = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.companys.push({ label: element.name, value: element.id });
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>


<style scoped>
</style>
  